<template>
  <div>
    <br/><br/>
    <table>
      <thead>
        <tr>
          <td></td>
          <td :key="item" v-for="item in data.datasets" width="90px">
            <span
              class="color"
              :style="{'background-color': generateTitleColor(item.label) + ' !important'}"
              v-if="typeof(item[1]) != 'object'">
            </span>
          </td>
        </tr>
      </thead>

      <tbody>
        <tr :key="choice" v-for="(choice, index) in choices">
          <td class="align-left">{{ choice }}</td>

          <td :key="result" v-for="result in data.datasets[index].data" class="align-center">
            {{ result }}
            <span v-if="isPercentage">%</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import colorMixin from '@/mixins/colors';
import chartMixin from './mixins/chartMixin';

export default {
  props: {
    isPercentage: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [chartMixin, colorMixin],
  computed: {
    choices() {
      return this.data.labels;
    },
  },
};
</script>

<style lang="scss" scoped>
.color {
  display: inline-block;
  width: 40px;
  height: 10px;
}

.align-left {
  text-align: left;
}

.align-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// StackedChartLegend.vue?40a81061